import 'intersection-observer';

export default class StickyElement {
	private element: HTMLElement = document.querySelector('.pageHeader__submenu');
	private parent: HTMLElement = document.querySelector('.pageHeader');
	private styleClass: string = 'stickyElement';
	private sentinel: HTMLElement;
	private sentinelStyleClass: string = 'stickyElementSentinel';

	private createSentinel() {
		const div = document.createElement('DIV');
		div.classList.add(this.sentinelStyleClass);
		div.style.height = this.element.clientHeight + 'px';
		this.sentinel = this.parent.insertBefore(div, this.element);
	};
	constructor() {
		if(this.element === null) {
			return;
		}
		this.createSentinel();

		const observer = new IntersectionObserver(
			([event]) => {
				let target = this.element;
				if (event.intersectionRatio < 1) {
					target.classList.add(this.styleClass);
				} else {
					target.classList.remove(this.styleClass);
				}
			},
			{ threshold: [0, 1] }
		);
		observer.observe(this.sentinel);
	}
}
